/**
 * Retrieval notices shown next to a chat answer.
 *
 * A notice explains why an answer rests on model knowledge alone although a
 * knowledge base is connected. The persona path reports a missing Axiom scope
 * as `axiom.scopeRequired`; the WebSocket path sends `notices: [{ code }]`.
 */
import { canOpenAdmin } from '../../utils/adminAccess.js';

/** Codes the chat has text for (i18n `chat.notice…`). Unknown codes are dropped. */
export const NOTICE_I18N = {
  axiom_scope_required: {
    title: 'chat.noticeAxiomScopeTitle',
    body: 'chat.noticeAxiomScopeBody',
    action: 'chat.noticeAxiomScopeAction',
  },
};

/**
 * The notice codes of a message, de-duplicated, known codes only.
 * @param {{ axiom?: { scopeRequired?: boolean }, notices?: Array<{ code?: string }> }|null} message
 * @returns {string[]}
 */
export function knowledgeNotices(message) {
  const codes = [];
  if (message?.axiom?.scopeRequired === true) codes.push('axiom_scope_required');
  for (const notice of Array.isArray(message?.notices) ? message.notices : []) {
    if (notice?.code) codes.push(notice.code);
  }
  return [...new Set(codes)].filter((code) => code in NOTICE_I18N);
}

/**
 * Where the reader fixes the cause. A tenant admin sets the scope for the
 * whole tenant; anyone else can set a personal one.
 */
export function noticeSettingsPath(code, user) {
  if (code === 'axiom_scope_required') {
    return canOpenAdmin(user) ? '/admin/tenant-defaults' : '/settings/tokens';
  }
  return null;
}
